export default __webpack_public_path__ + "static/media/default.ebe1cfe9.svg";